/** 
 * @typedef {(attribute: import("../xmlrdb-data/Attribute").default) => import("./ValidationError").default | String | undefined} ValidatorFunction 
 * */

export default {
  /** @type {ValidatorFunction} */
  required(attr) {
    if (attr.value === null || attr.value === ""){
      return `"${attr.metadata.label()}" ist ein Pflichtfeld.`
    }
  },

  /** @type {ValidatorFunction} */
  numericMaxLength(attr) {
    let maxValue = Math.pow(10, attr.metadata.maxLength() - attr.metadata.precision());
    let minValue = Math.pow(10 , - attr.metadata.precision());
    if (attr.value >= maxValue) {
      return "Zahl ist zu groß. Wert muss kleiner als: " + (maxValue).toLocaleString() +" sein.";
    }
    return undefined
  },

  /** @type {ValidatorFunction} */
  minLength(attr) {
    const minLength = attr.metadata.minLength();
    if (!minLength) return undefined;
    if (attr.value === null || attr.value.length < minLength) {
      return `"${attr.metadata.label()}" muss mindestens ${minLength} Zeichen lang sein.`
    }
  },

  IsNotNullOnFlag(attr) {
    const IsNotNullOnFlag = attr.metadata.tagByName("IsNotNullOnFlag");
    if (IsNotNullOnFlag == null) {
      throw `Für Attribut {} wurde als Validator "IsNotNullOnFlag" angegeben, aber es ist kein Tag "IsNotNullOnFlag" gesetzt. "IsNotNullOnFlag" muss den Namen des  Flags beinhalten, das abgefragt werden soll.`
    }
    const flag = attr.dataElement.$[IsNotNullOnFlag];
    if (flag.value && (attr.value === null || attr.value === "")) {
      return `"${attr.metadata.label()}" ist ein Pflichtfeld, da "${flag.metadata.label()}" gesetzt ist.`
    }
  },

  IsNotNullOnNotFlag(attr) {
    const IsNotNullOnFlag = attr.metadata.tagByName("IsNotNullOnFlag");
    if (IsNotNullOnFlag == null) {
      throw `Für Attribut {} wurde als Validator "IsNotNullOnFlag" angegeben, aber es ist kein Tag "IsNotNullOnFlag" gesetzt. "IsNotNullOnFlag" muss den Namen des  Flags beinhalten, das abgefragt werden soll.`
    }
    const flag = attr.dataElement.$[IsNotNullOnFlag];
    if ((flag.value !== null && !flag.value) && (attr.value === null || attr.value === "")) {
      return `"${attr.metadata.label()}" ist ein Pflichtfeld, da "${flag.metadata.label()}" ungesetzt ist.`
    }
  }
}